import React from 'react'
import { useFormContext, Controller, useFieldArray } from 'react-hook-form'
import Select from 'react-select'
import {FaRegMinusSquare,FaRegPlusSquare } from 'react-icons/fa'

export const ControlSelectArr = ({name, options, labelClass, active = true, displayBtns = true, label = "Seznam léčiv", ...props  }) => {
    const methods = useFormContext
    const control = methods.control
    const {fields, remove, append} = useFieldArray({name: name, control})

    const styles = {
        control: (props) => ({
            ...props,
            borderRadius: 0,
            minHeight: 42,
        })}

    return (
        fields.map ((item,i) => (
            <div className='input-group' key={item.id}>
                <label className={labelClass}>{label}</label>
                <Controller name={`${name}.${i}`} control={methods.control} render = { ( {field} ) => (
                    <Select isClearable {...field} options = {options} styles={styles} isDisabled= {active} placeholder='Vyberte...' {...props} /> )}
                />
                {/* Add logic to dispaly icons */}
                { displayBtns && 
                <div className='input-icons'>
                    <a onClick={() => append ({value: "", label: "Vyberte..."})}>
                        <FaRegPlusSquare id="plus" />
                    </a>
                    <a onClick={() => { fields.length <= 1 ? alert("Nemůžete odstranit všechna léčiva") : remove(i) } }>
                        <FaRegMinusSquare id="minus" />
                    </a>
                </div> 
                }
            </div>
        ))
    )
}